import { render, staticRenderFns } from "./videochat.vue?vue&type=template&id=753d8297&"
import script from "./videochat.vue?vue&type=script&lang=js&"
export * from "./videochat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports